<div class="unlock-account-dialog">
    <h3>🔓 Déverrouillage du compte</h3>

    <p>
    Vous êtes sur le point de déverrouiller ce compte utilisateur.
    </p>

    <p>
    <strong>Confirmez-vous cette opération ?</strong>
    </p>

    <div class="actions">
    <button mat-stroked-button (click)="cancel()">
        Annuler
    </button>

    <button mat-raised-button color="primary" (click)="confirm()">
        Déverrouiller
    </button>
    </div>
</div>